const state = {
  CurrencySymbol: "",
  CurrencyCode: "",
  SystemBalance: 0,
  CreditBalance: 0,
  BalanceStatus: 0,
}
const getters = {
  getCurrencySymbol: state => {
    return state.CurrencySymbol
  },
  getSystemBalance: state => {
    return state.SystemBalance
  },
  getCreditBalance: state => {
    return state.CreditBalance
  },
  getBalanceStatus: state => {
    return state.BalanceStatus
  },
  getCurrencyCode: state => {
    return state.CurrencyCode
  }
}
const mutations = {
  setCurrencySymbol(state, value) {
    state.CurrencySymbol = value
  },
  setSystemBalance(state, value) {
    state.SystemBalance = value
  },
  setCreditBalance(state, value) {
    state.CreditBalance = value
  },
  setBalanceStatus(state, value) {
    state.BalanceStatus = value
  },
  setCurrencyCode(state, value) {
    state.CurrencyCode = value
  }
}
const actions = {
  setCurrencySymbol({commit}, value) {
    commit('setCurrencySymbol', value)
  },
  setSystemBalance({commit}, value) {
    commit('setSystemBalance', value)
  },
  setCreditBalance({commit}, value) {
    commit('setCreditBalance', value)
  },
  setBalanceStatus({commit}, value) {
    commit('setBalanceStatus', value)
  },
  setCurrencyCode({commit}, value) {
    commit('setCurrencyCode', value)
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/SMBData.js